var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 36,
    viewBox: "0 0 22 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 17.7684C0 18.5017 0.311715 19.2026 0.86176 19.7061L17.3613 34.8095C18.4654 35.8202 20.2058 35.772 21.2486 34.7019C22.2915 33.6317 22.2417 31.9448 21.1376 30.9341L6.7549 17.7684L21.1376 4.60272C22.2417 3.59212 22.2915 1.90521 21.2486 0.835087C20.2058 -0.235252 18.4654 -0.283451 17.3613 0.727364L0.86176 15.8307C0.311715 16.3342 0 17.0351 0 17.7684Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.a1e2c3fc0b64d46f1c648eb59abc054b.svg";
export { ForwardRef as ReactComponent };